import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FiberManualRecord as DotSeparatorIcon } from '@material-ui/icons';
import ImageAddress from './ImageAddress';
import { ImageMetaDataProps } from '../../types';
import { popupStyles } from '../styles/popupStyles';

const styles = (theme: any) => ({
  header: popupStyles(theme).imageMetaDataHeader,
  footer: popupStyles(theme).imageMetaDataFooter,
  edrFooter: popupStyles(theme).imageMetaDataEdrFooter,
  row: popupStyles(theme).imageMetaDataRow,
  date: popupStyles(theme).imageMetaDataDate,
  separator: popupStyles(theme).imageMetaDataSeparator,
});

const ImageMetaData: React.FC<ImageMetaDataProps> = ({
  children,
  date,
  time,
  address,
  isEDR = false,
  classes,
}) => {
  if (!date && !address) {
    return <>{children}</>;
  }

  return (
    <div className={classes!.header}>
      {children}
      <div className={isEDR ? classes!.edrFooter : classes!.footer}>
        <div className={classes!.row}>
          {date && time && (
            <span className={classes!.date}>
              {date} <DotSeparatorIcon className={classes!.separator} /> {time}
            </span>
          )}
        </div>
        {address && <ImageAddress address={address} />}
      </div>
    </div>
  );
};

export default withStyles(styles)(ImageMetaData);
